module.exports = __webpack_public_path__ + "img/oil_paint_3.65ba173f.png";